const posts = $('.s-featured-related__posts');
if (posts.length > 0) {
    // delay loading script until the document is fully ready
    document.onreadystatechange = function () {
        // The document and all sub-resources have finished loading. The state indicates that the load event is about to fire
        if (document.readyState === 'complete') {
            sliderItems();
        }
    };

    // load the script on screen resize
    window.onresize = function () {
        sliderItems();
    };
}

/**
 * Position expandable items in the right place
 */


function sliderItems() {
    // variables

    if (window.innerWidth < 768) {
        posts.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            arrows: false,
            dots: false,
        })
    } else {
        posts.slick('unslick');
    }
}



// WEBPACK FOOTER //
// ./scripts/routes/sections/featured-related.js